// extracted by mini-css-extract-plugin
module.exports = {"cookieBar":"cookie-bar-module--cookie-bar--Wi1P7","visible":"cookie-bar-module--visible--1fN7G","hidden":"cookie-bar-module--hidden--hefHV","btn":"cookie-bar-module--btn--3yILN"};